export const XRefDirective = function (RouterService, $rootScope) {
  return {
    restrict: 'A',
    scope   : {
      scTitle: '@',
      scXref : '@',
    },
    link    : (scope, element, attrs) => {
      const onClick = () => {
        RouterService.openFrame(scope.scXref);
        $rootScope.$digest();
      };
      element.bind('click', onClick);
      // scope.$on('$destroy', () => {});
    },
  };
};



// WEBPACK FOOTER //
// ./src/shared/xref.directive.js